/**
 * 邮件
 */

 import axios from '@/utils/request'

 export default {
   getEmailTaskList: (params) => axios({ url: '/api/message/emailTasks', method: 'GET', params }), // 邮件列表
   addEmailTask: (data) => axios({ url: '/api/message/emailTask', method: 'POST', data }), // 添加邮件
   deleteEmailTask:id => axios({ url: `/api/message/emailTask/${id}`, method: 'DELETE'}), // 删除邮件
   getEmailTaskDetail:id => axios({ url: `/api/message/emailTask/${id}`, method: 'GET'}), // 邮件详情
   getEmailTaskeMailReplaceTemplateList:params => axios({ url: `/api/message/emailAttributesConfigList`, method: 'GET', params}), // 后台-获取邮件事件替换内容模板列表
   getEmailTaskeEmailReplacePreview:data => axios({ url: `/api/message/emailReplacePreview`, method: 'post', data}), // 后台-获取占位符替换预览
   messageEmailEvents:params => axios({ url: `/api/message/messageEmailEvents`, method: 'get', params}), // 获取邮件事件列表
}
 